/**
 * @description: 根据文章等级做页面样式控制-配置文件
 * @param {*} Sgrade 文章等级，当前有S+、S、S-、A四类
 * @return {配置对象}
 */
import Vue from "vue";
import  {jsonp} from '../request/jsonp'
import NumberFix from "../utils/number-text"
import LeftBottomBaiduAd from "@/components/adver/baidu-index"
import ArticleLike from '../vuecomps/articleLike.vue' // 文末点赞
import { renderRightSideBar } from '@/pages/article_main/js/handleDom'
import ad from '@/components/adver/article_abroad_ad'
import { hideDom } from '@/utils/Utils' 

var SgradeMap = ['A', 'S-', 'S', 'S+']

export default function (opts) {
    var Sgrade = opts.sGrade
    var ArtGrade = SgradeMap[Number(Sgrade)]
    console.log('Grade_abroad:', ArtGrade)
    if (ArtGrade === 'S+') {
        hideDom('.left-bottom-float-fullScreenSleepContainer') // 全屏广告
        hideDom('#container') // 左下角广告
        hideDom('.taboolaContainer') // tbl广告
        hideDom('.statement') // 平台声明
    }
    if (ArtGrade === 'S') {
        hideDom('.left-bottom-float-fullScreenSleepContainer') // 全屏广告
        hideDom('#container') // 左下角广告
        hideDom('.taboolaContainer') // tbl广告
        hideDom('.statement') // 平台声明
    }
    if (ArtGrade === 'S-') {
        hideDom('.left-bottom-float-fullScreenSleepContainer') // 全屏广告
        hideDom('#container') // 左下角广告
        hideDom('.taboolaContainer') // tbl广告
        // 去广告
        opts.removeAd = true
        // 推荐阅读
        renderRecommendFeed()
    }
    if (ArtGrade === 'A') {
        // 右边栏
        renderRightSideBar()
        // 文末点赞
        if(document.querySelector('#article-like')) {
            new Vue({
                el: "#article-like",
                components: {
                    articleLike: ArticleLike
                },
            })
        }
        ad.init({
            news_id: opts.news_id,
            media_id: opts.media_id,
            channel_id: opts.channel_id,
            categoryId: opts.categoryId,
            subid: opts.media_id,
            abData: opts.abData,
            secureScore: opts && opts.secureScore,
            showAd: opts.sGrade == 0,
        })
        // 推荐阅读
        renderRecommendFeed()
        // 底部悬浮广告
        LeftBottomBaiduAd({
            el: '#left-bottom-god',
            secureScore: opts.secureScore,
            channel_id: opts.channel_id,
            media_id: opts.media_id,
            news_id: opts.news_id,
        });
    }
    handleReprint()
    renderArticlePv()
}
// 推荐阅读
const renderRecommendFeed = function() {
    if(!document.querySelector('#groomRead')) return
    import(/* webpackChunkName: "article_recommend" */'../vuecomps/groomRead.vue')
    .then((res)=>{
        const comp = res.default
        new Vue({
            el: "#groomRead",
            components: {
                GroomRead: comp
            }
        })
    }).catch((e)=>{
        console.log('渲染失败，推荐阅读',e)
    })
}

//请求转载文章信息 有originalId才发送请求
const handleReprint = function() {
    const pcArticleInfo = window?.pcArticleInfo
    var isPort = pcArticleInfo?.originalStatus == 2 && pcArticleInfo?.originalId && pcArticleInfo?.originalId != 'null';
    if (isPort) {
        import(/* webpackChunkName: "article_transfer" */'../vuecomps/articleReprint.vue')
        .then((res)=>{
            if(res && res.default) {
                const comp = res.default
                new Vue({
                    el: "#articleTransfer",
                    components: {
                        transfer: comp
                    },
                })
            }
        }).catch((e)=>{
            console.log('渲染失败，请求转载文章信息',e)
        })
    }
}
// 前端请求pv
const renderArticlePv = ()=>{
    const articleId = window?.pcArticleInfo?.news_id
        jsonp(`//v2.sohu.com/public-api/articles/${articleId}/pv`).then((data)=>{
            if(data) {
                const pvDom = document.querySelector("[data-role='pv']")
                if(pvDom)pvDom.innerHTML = new NumberFix(data).format()
            }
        }).catch((err)=>{
    })
}
